"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VcfSubscriptionsSettingsService = void 0;
const types_1 = require("../shared/types");
const NoSubscriptionSettingsFoundError_1 = require("./errors/NoSubscriptionSettingsFoundError");
class VcfSubscriptionsSettingsService {
    constructor(vcfSubscriptionsSettingsClient, loggingFacade) {
        this.vcfSubscriptionsSettingsClient = vcfSubscriptionsSettingsClient;
        this.loggingFacade = loggingFacade;
    }
    async retainTheftAlarmCapableVehicles(vehicles) {
        const filterUndefinedVehicles = (vehicle) => vehicle !== undefined;
        const sortRequestSuccessVehiclesFirst = (vehicle) => { var _a; return ((_a = vehicle === null || vehicle === void 0 ? void 0 : vehicle.requestFailed) !== null && _a !== void 0 ? _a : false) ? 1 : -1; };
        const sortPrimaryVehicleFirst = (vehicle) => (vehicle === null || vehicle === void 0 ? void 0 : vehicle.primaryCar) && !!(vehicle === null || vehicle === void 0 ? void 0 : vehicle.requestFailed) ? -1 : 1;
        const vehiclesWithoutGuestUsers = vehicles.filter((vehicle) => vehicle.role !== types_1.Role.GUEST_USER);
        const theftAlarmVehicles = await Promise.all(vehiclesWithoutGuestUsers.map((vehicle) => this.getTheftAlarmSettings(vehicle)));
        return theftAlarmVehicles
            .filter(filterUndefinedVehicles)
            .sort(sortPrimaryVehicleFirst)
            .sort(sortRequestSuccessVehiclesFirst);
    }
    async saveTheftAlarmSettings(vehicle) {
        const isWcar = vehicle.devicePlatform === types_1.DevicePlatform.WCAR;
        const settings = [
            {
                id: 'theftalarm',
                eMail: vehicle.email,
                push: vehicle.push,
            },
        ];
        await this.vcfSubscriptionsSettingsClient.saveSubscriptionsSettings(vehicle.vin, isWcar, settings);
    }
    async getTheftAlarmSettings(vehicle) {
        var _a, _b, _c, _d;
        const isWcar = vehicle.devicePlatform === types_1.DevicePlatform.WCAR;
        try {
            const settings = await this.vcfSubscriptionsSettingsClient.getSubscriptionsSettings(vehicle.vin, isWcar);
            const settingsWithTheftAlarmTopic = (_b = (_a = settings === null || settings === void 0 ? void 0 : settings.data) === null || _a === void 0 ? void 0 : _a.topics) === null || _b === void 0 ? void 0 : _b.find((topic) => topic.id === 'theftalarm');
            if (settingsWithTheftAlarmTopic !== undefined) {
                return Object.assign(Object.assign({}, vehicle), { email: (_c = settingsWithTheftAlarmTopic.eMail) !== null && _c !== void 0 ? _c : false, push: (_d = settingsWithTheftAlarmTopic.push) !== null && _d !== void 0 ? _d : false });
            }
        }
        catch (e) {
            if (!(e instanceof NoSubscriptionSettingsFoundError_1.NoSubscriptionSettingsFoundError)) {
                this.loggingFacade.error(`Error fetching subscriptions settings for vin: ${vehicle.vin}`, e);
                return Object.assign(Object.assign({}, vehicle), { email: false, push: false, requestFailed: true });
            }
        }
        return undefined;
    }
}
exports.VcfSubscriptionsSettingsService = VcfSubscriptionsSettingsService;
//# sourceMappingURL=VcfSubscriptionsSettingsService.js.map